module.exports = __webpack_public_path__ + "static/media/birthday-cake.d77db7a3.svg";